interface InviteOptions {
  org_name?: string;
  checkout_url?: string;
  onboarding_url?: string;
  redirect_to?: string;
  send_now?: boolean;
}

interface InviteResponse {
  sent?: boolean;
  subject?: string;
  body?: string;
  error?: string;
}

type BearerHeaders = { Authorization: string } | null;

export async function inviteSponsorRequest(
  bearer: BearerHeaders,
  email: string,
  {
    org_name = '',
    checkout_url,
    onboarding_url,
    redirect_to,
    send_now = false,
  }: InviteOptions = {}
): Promise<InviteResponse> {
  if (!bearer || !bearer.Authorization) {
    throw new Error('Not authenticated');
  }
  const payload = {
    email,
    org_name,
    checkout_url,
    onboarding_url,
    redirect_to,
    send_now,
  };
  const res = await fetch('/api/v1/admin/sponsors/invite', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...bearer,
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({})) as InviteResponse;
  if (!res.ok) {
    throw new Error(data?.error || 'Failed to prepare sponsor invite');
  }
  return data;
}
